import {
  init as initAmplitude,
  track as trackAmplitude,
  type Types as AmplitudeTypes,
} from '@amplitude/analytics-browser';
import {
  type AnalyticsEvent,
  type AnalyticsImplementation,
  type ConfigApi,
} from '@backstage/frontend-plugin-api';

function getServerZone(
  configApi: ConfigApi,
): AmplitudeTypes.ServerZoneType | undefined {
  const serverZone = configApi
    .getOptionalString('app.analytics.amplitude.serverZone')
    ?.toUpperCase();

  if (serverZone === 'EU' || serverZone === 'US') {
    return serverZone;
  }

  return undefined;
}

export class AmplitudeAnalytics implements AnalyticsImplementation {
  static fromConfig(configApi: ConfigApi): AmplitudeAnalytics {
    const apiKey = configApi.getOptionalString(
      'app.analytics.amplitude.apiKey',
    );
    const enabled =
      configApi.getOptionalBoolean('app.analytics.amplitude.enabled') ??
      Boolean(apiKey);

    if (!enabled || !apiKey) {
      return new AmplitudeAnalytics(false);
    }

    initAmplitude(apiKey, {
      autocapture: {
        attribution: false,
        elementInteractions: false,
        fileDownloads: false,
        formInteractions: false,
        frustrationInteractions: false,
        networkTracking: false,
        pageUrlEnrichment: true,
        pageViews: true,
        performanceTracking: false,
        sessions: true,
        webVitals: false,
      },
      serverZone: getServerZone(configApi),
    });

    return new AmplitudeAnalytics(true);
  }

  private constructor(private readonly enabled: boolean) {}

  captureEvent(event: AnalyticsEvent): void {
    if (!this.enabled) {
      return;
    }

    trackAmplitude(event.action, {
      subject: event.subject,
      ...event.context,
      ...event.attributes,
      ...(event.value === undefined ? {} : { value: event.value }),
    });
  }
}
